import {
  getSelectedSubGroupIds,
  getType,
  RECIPIENT_TYPE_EVERY_ONE,
} from 'app/main/notification/selectRecipient/RecipientState'
import * as R from 'ramda'
import {
  EVERYONE_TYPE,
  SUB_GROUP_TYPE,
  SUBSCRIBERS_NOT_IN_GROUP_TYPE,
} from 'app/constants/recipient'
export const getSubGroupsQueryParams = (recipients) => {
  const type = getType(recipients)
  if (type === RECIPIENT_TYPE_EVERY_ONE) return undefined
  else
    return R.ifElse(
      R.anyPass([R.isEmpty, R.isNil]),
      R.always(undefined),
      R.compose(R.join(','), getSelectedSubGroupIds),
    )(recipients)
}

export const getSubGroupsQueryParamsNewFunction = (recipients) => {
  // return null
  if (R.isNil(recipients)) return null
  return R.compose(
    R.join(','),
    R.map(R.prop('id')),
    R.filter((item) =>
      R.includes(R.prop('type', item), [
        SUB_GROUP_TYPE,
        SUBSCRIBERS_NOT_IN_GROUP_TYPE,
        EVERYONE_TYPE,
      ]),
    ),
  )(recipients)
}

export const getSubscribersQueryParams = (recipients) => {
  if (R.isEmpty(recipients)) return null

  return R.ifElse(
    R.isNil,
    R.always(null),
    R.compose(
      R.join(','),
      R.map(R.prop('id')),
      R.filter(R.propEq('type', 'subscribers')),
    ),
  )(recipients)
}

export const getTopicIdsQueryParams = (topics) => {
  if (R.isNil(topics)) return null
  return R.ifElse(
    R.isNil,
    R.always(null),
    R.compose(R.join(','), R.map(R.prop('id'))),
  )(topics)
}

export const getChannelsQueryParams = (channels) => {
  if (R.isNil(channels)) return null
  return R.ifElse(R.isNil, R.always(null), R.join(','))(channels)
}
